export default __webpack_public_path__ + "static/Pc_Eyes-3b312c07a53b237836e01e22dc99fd5f.png";